import 'gleam-shared/lazyEmbed/placeholder.scss'
import onceAnimationEnds from 'gleam-shared/browser/onceAnimationEnds'

const ROOT_CLASS = 'lazy-embed__placeholder-root'
const TEXT_CLASS = 'lazy-embed__placeholder-text'
const ERROR_ICON_CLASS = 'lazy-embed__placeholder-error-icon'
const TIMEOUT_ICON_CLASS = 'lazy-embed__placeholder-timeout-icon'
const SPINNER_ICON_CLASS = 'lazy-embed__placeholder-spinner-icon'
const BACKGROUND_CLASS = 'lazy-embed__placeholder-background'
const BACKGROUND_FADEOUT_CLASS = 'lazy-embed__placeholder-background--fadeout'
const FADEOUT_ANIMATION = 'fade-out-animation'

export function showError(el, alert) {
  clearBackground(el)
  appendAlert(el, alert, ERROR_ICON_CLASS)
}

export function showTimeout(el, alert) {
  clearBackground(el)
  appendAlert(el, alert, TIMEOUT_ICON_CLASS)
}

export function showSpinner(el) {
  clearBackground(el)
  appendSpinner(el)
}

export function hidePlaceholder(el, callback) {
  const background = findBackground(el)

  if (background) {
    background.classList.add(BACKGROUND_FADEOUT_CLASS)
    onceAnimationEnds(background, FADEOUT_ANIMATION, callback)
  } else {
    setTimeout(callback)
  }
}

export function removePlaceholder(el) {
  const background = findBackground(el)
  el.classList.remove(ROOT_CLASS)
  background?.remove()
}

function appendAlert(el, error, iconClass) {
  const background = appendBackground(el)
  const icon = document.createElement('section')
  const text = document.createElement('section')
  icon.classList.add(iconClass)
  text.classList.add(TEXT_CLASS)
  text.innerText = error.message
  background.append(icon)
  background.append(text)
}

function appendSpinner(el) {
  const background = appendBackground(el)
  const icon = document.createElement('section')
  icon.classList.add(SPINNER_ICON_CLASS)
  background.append(icon)
}

function clearBackground(el) {
  const background = findBackground(el)

  while (background?.firstChild) {
    background.firstChild.remove()
  }
}

function appendBackground(el) {
  const existing = findBackground(el)

  if (existing) {
    return existing
  }

  const background = document.createElement('section')
  background.classList.add(BACKGROUND_CLASS)
  el.append(background)
  el.classList.add(ROOT_CLASS)

  return background
}

function findBackground(el) {
  return el.getElementsByClassName(BACKGROUND_CLASS)[0]
}
